import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from 'constants/constants'
import { EVALUATION_CONTEXT } from '../features/discover/utils'
import { query } from '../graphql'

/**
 * careerId ist optional. Mit ihr normiert das Backend die Teamwerte wie das
 * Matching der Stelle, damit die Anforderungsbereiche im Teamprofil auf
 * derselben Skala liegen wie im Passungsprofil.
 */
export const useTeamProfileQuery = ({
  spaceIds,
  careerId,
  language,
  ...options
}) => {
  return useQuery({
    queryKey: QUERY_KEYS.teamProfile(spaceIds, language, careerId),
    queryFn: async () => {
      const variables = {
        action: 'generateText',
        space_ids: spaceIds,
        language,
        text_generation_context: EVALUATION_CONTEXT.TEAMPROFILE,
        ...(careerId && { career_id: careerId })
      }

      const response = await query({ query: 'helperControl', variables })
      if (!response || response === 'undefined') {
        console.error('TEAMPROFILE: Invalid response received:', response)
        throw new Error('Invalid response from helperControl query')
      }

      try {
        const parsed = JSON.parse(response)
        if (!parsed?.body?.generateText?.res) {
          console.error('TEAMPROFILE: Invalid response structure:', parsed)
          throw new Error('Invalid response structure from helperControl')
        }
        return parsed.body.generateText.res
      } catch (error) {
        console.error(
          'TEAMPROFILE: JSON parse error:',
          error,
          'Response:',
          response
        )
        throw new Error(
          `Failed to parse team profile response: ${error.message}`
        )
      }
    },
    ...options
  })
}
